import { all, takeLatest } from 'redux-saga/effects';

import * as actionTypes from '../actionTypes';

import { sendRetenoAnalytics } from './sendRetenoAnalytics';

export default function* watchAnalytics() {
    yield all([takeLatest(actionTypes.SEND_RETENO_ANALYTICS_REQUEST, sendRetenoAnalytics)]);
}
